import React, { CSSProperties, useRef } from 'react';
import { FontWeightType } from './Text';

interface ButtonType {
  text:string,
  onPress():Promise<void> | void,
  style?:CSSProperties,
  disable?:boolean
}
export const MainButton : React.FC<ButtonType> = (props:ButtonType) => {
  const doubleClick = useRef<boolean>(false);
  const onClick = async () => {
    if (doubleClick.current) {
      return;
    }
    try {
      doubleClick.current = true;
      await props.onPress();
    } catch (e) {
      console.error(e);
    } finally {
      doubleClick.current = false;
    }
  };
  return (
    <input
      type="button"
      value={props.text}
      disabled={props.disable === true}
      style={{
        backgroundColor: props.disable === true ? '#C6C6C6' : '#312719',
        paddingBlock: 10,
        paddingInline: 72,
        color: 'white',
        fontWeight: FontWeightType.w700,
        fontSize: 17,
        fontFamily: 'inter',
        ...props.style,
      }}
      onClick={() => {
        onClick().catch(() => {});
      }}
    />
  );
};

export const SubButton : React.FC<ButtonType> = (props:ButtonType) => {
  const doubleClick = useRef<boolean>(false);
  const onClick = async () => {
    if (doubleClick.current) {
      return;
    }
    try {
      doubleClick.current = true;
      await props.onPress();
    } catch (e) {
      console.error(e);
    } finally {
      doubleClick.current = false;
    }
  };
  return (
    <input
      type="button"
      value={props.text}
      disabled={props.disable === true}
      style={{
        color: '#312719',
        paddingBlock: 10,
        paddingInline: 72,
        border: '1px solid #312719',
        backgroundColor: '#F9F4EF',
        fontWeight: FontWeightType.w700,
        fontSize: 17,
        fontFamily: 'inter',
        ...props.style,
      }}
      onClick={onClick}
    />
  );
};
